import { EventTypes, track } from '@mc/track-event'

export const trackMarketingAction = (copy: string, slug: string) => () => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    subscription_id: {},
    active_annual_pass: false,
    class: slug,
    category: 'class-navigation',
    location: 'hero',
    action: copy,
  })
}
